import { useState, useEffect, useRef } from "react";
import useOffers from "./useOffers";

function useAdminOffers(editingOffer = null, onSuccess = null) {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    product: "",
    discountType: "percentage",
    discountValue: "",
    startDate: "",
    endDate: "",
    isActive: true,
    image: null,
  });

  const formDataRef = useRef(new FormData());

  const { createOffer, updateOffer, isCreatingOffer, isUpdatingOffer } =
    useOffers(null, onSuccess);

  // Initialize form data when editing
  useEffect(() => {
    if (editingOffer) {
      const formattedData = {
        title: editingOffer.title || "",
        description: editingOffer.description || "",
        product: editingOffer.product?._id || editingOffer.product || "",
        productName: editingOffer.product?.name || "",
        discountType: editingOffer.discountType || "percentage",
        discountValue:
          editingOffer.discountValue || editingOffer.discountPercentage || "",
        startDate: editingOffer.startDate
          ? new Date(editingOffer.startDate).toISOString().split("T")[0]
          : "",
        endDate: editingOffer.endDate
          ? new Date(editingOffer.endDate).toISOString().split("T")[0]
          : "",
        isActive:
          editingOffer.isActive !== undefined ? editingOffer.isActive : true,
      };

      setFormData(formattedData);
    }
  }, [editingOffer]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingOffer) {
        // Update existing offer - prepare FormData
        formDataRef.current = new FormData();

        // Prepare the offer data
        const offerData = {
          ...formData,
          discountValue:
            formData.discountType === "fixed"
              ? Number(formData.discountValue)
              : 0,
          discountPercentage:
            formData.discountType === "percentage"
              ? Number(formData.discountValue)
              : 0,
        };

        // Append all fields to FormData
        Object.keys(offerData).forEach((key) => {
          if (offerData[key] !== null && offerData[key] !== undefined) {
            formDataRef.current.append(key, offerData[key]);
          }
        });

        updateOffer({ offerId: editingOffer._id, offer: formDataRef });
      } else {
        // Create new offer
        createOffer(formData);
      }
    } catch (error) {
      // Error handling is managed by the useOffers hook
    }
  };

  const resetForm = () => {
    setFormData({
      title: "",
      description: "",
      product: "",
      discountType: "percentage",
      discountValue: "",
      startDate: "",
      endDate: "",
      isActive: true,
      image: null,
    });
  };

  return {
    // State
    formData,
    setFormData,

    // Actions
    handleSubmit,
    resetForm,

    // Loading states
    isCreatingOffer,
    isUpdatingOffer,
    isLoading: isCreatingOffer || isUpdatingOffer,
  };
}

export default useAdminOffers;
